import type { CrossJoinIntegration } from '@atlassian/cross-join-nudges';

import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance.ts';
import { keys as localStorageKeys } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';

const EXPIRY_IN_7_DAYS = 60 * 60 * 24 * 7;
const EXPIRY_IN_30_DAYS = 60 * 60 * 24 * 30;

export const isFeatureVisited = async (integration: CrossJoinIntegration): Promise<boolean> => {
	try {
		if (getFeatureVisited(integration)) {
			return true;
		}
		void snoozeFeatureFor7Days(integration);
		if (!getFeatureVisited(integration)) {
			return true;
		}
		return false;
	} catch {
		return true;
	}
};

export const getFeatureVisitedCount = (integration: CrossJoinIntegration): number => {
	const value = localStorage.getItem(getVisitedCountStorageKey(integration));
	return parseInt(value, 10) || 0;
};

export const increaseFeatureVisitedCount = (integration: CrossJoinIntegration) => {
	const currentCount = getFeatureVisitedCount(integration);
	localStorage.setItem(getVisitedCountStorageKey(integration), currentCount + 1);
};

export const snoozeFeatureFor7Days = (integration: CrossJoinIntegration) => {
	setFeatureVisited(integration, EXPIRY_IN_7_DAYS);
};

export const snoozeFeatureFor30Days = (integration: CrossJoinIntegration) => {
	setFeatureVisited(integration, EXPIRY_IN_30_DAYS);
};

const setFeatureVisited = (integration: CrossJoinIntegration, expire: number) => {
	localStorage.setItem(getVisitedStorageKey(integration), true, expire);
};

export const getFeatureVisited = (integration: CrossJoinIntegration): boolean =>
	localStorage.getItemAsBoolean(getVisitedStorageKey(integration));

export const setUserOptedOut = (integration: CrossJoinIntegration) => {
	localStorage.setItem(getOptOutStorageKey(integration), true);
};

export const isUserOptedOut = (integration: CrossJoinIntegration) =>
	localStorage.getItemAsBoolean(getOptOutStorageKey(integration));

function getOptOutStorageKey(integration: CrossJoinIntegration): string {
	switch (integration) {
		case 'crossJoinNudgesV3':
			return localStorageKeys.CROSS_JOIN_NUDGES_V3_USER_OPT_OUT;
		case 'crossJoinNudgesConfluenceToJpd':
			return localStorageKeys.CROSS_JOIN_NUDGES_JPD_USER_OPT_OUT;
		case 'crossJoinNudgesConfluenceToLoom':
			return localStorageKeys.CROSS_JOIN_NUDGES_LOOM_OPT_OUT;
		default: // error TS2366: Function lacks ending return statement and return type does not include 'undefined'.
			return '';
	}
}

function getVisitedStorageKey(integration: CrossJoinIntegration): string {
	switch (integration) {
		case 'crossJoinNudgesV3':
			return localStorageKeys.CROSS_JOIN_NUDGES_V3_VISITED_KEY;
		case 'crossJoinNudgesConfluenceToJpd':
			return localStorageKeys.CROSS_JOIN_NUDGES_JPD_VISITED_KEY;
		case 'crossJoinNudgesConfluenceToLoom':
			return localStorageKeys.CROSS_JOIN_NUDGES_LOOM_VISITED_KEY;
		default: // error TS2366: Function lacks ending return statement and return type does not include 'undefined'.
			return '';
	}
}

function getVisitedCountStorageKey(integration: CrossJoinIntegration): string {
	switch (integration) {
		case 'crossJoinNudgesV3':
			return localStorageKeys.CROSS_JOIN_NUDGES_V3_VISITED_COUNT;
		case 'crossJoinNudgesConfluenceToJpd':
			return localStorageKeys.CROSS_JOIN_NUDGES_JPD_VISITED_COUNT;
		case 'crossJoinNudgesConfluenceToLoom':
			return localStorageKeys.CROSS_JOIN_NUDGES_LOOM_VISITED_COUNT;
		default: // error TS2366: Function lacks ending return statement and return type does not include 'undefined'.
			return '';
	}
}
